import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import ProcesosActivos from './pages/ProcesosActivos';
import ClientesList from './pages/ClientesList';
import ProcesoDetalle from './pages/ProcesoDetalle'; 
import CandidatosGlobalList from './pages/CandidatosGlobalList';
import Reportes from './pages/Reportes';
import Cotizaciones from './pages/Cotizaciones';
import CotizacionesList from './pages/CotizacionesList';
import Login from './pages/Login';
import UserManagement from './pages/UserManagement';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Ruta Pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas Protegidas */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="procesos" element={<ProcesosActivos />} />
              <Route path="procesos/:id" element={<ProcesoDetalle />} />
              <Route path="candidatos" element={<CandidatosGlobalList />} />
              <Route path="clientes" element={<ClientesList />} />
              <Route path="reportes" element={<Reportes />} />
              <Route path="cotizaciones" element={<CotizacionesList />} />
              <Route path="cotizaciones/nueva" element={<Cotizaciones />} />
              <Route path="cotizaciones/:id" element={<Cotizaciones />} />
              
              {/* Gestión de Usuarios (Solo SuperAdmin) */}
              <Route path="usuarios" element={<UserManagement />} />
            </Route>
          </Route>

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;